import { NgModule } from '@angular/core';
import { FLXLoadingSpinnerComponent } from './loading-spinner.component';
import { CommonModule } from '@angular/common';
@NgModule({
	imports: [CommonModule],
	declarations: [FLXLoadingSpinnerComponent],
	exports: [FLXLoadingSpinnerComponent]
})
export class FLXLoadingSpinnerModule {}
